import { render } from "./DashboardScreen2.vue?vue&type=template&id=c770696c&scoped=true"
import script from "./DashboardScreen2.vue?vue&type=script&lang=js"
export * from "./DashboardScreen2.vue?vue&type=script&lang=js"

import "./DashboardScreen2.vue?vue&type=style&index=0&id=c770696c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c770696c"]])

export default __exports__